<div [formGroup]='formGroup' class='ForgotPassword container'>
  <div class='row'>
    <div class='col col-12'>
      <h4 class='ForgotPassword__header'>Change your password?</h4>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 d-flex flex-column'>
      <mat-label class='font-weight-bolder'>New password</mat-label>
      <app-text-field formControlName='new_password' placeholder='Enter your new password'
                      type='password'></app-text-field>
      <div *ngIf='hasControlErrors(new_password)' class='alert alert-danger'>
        <div *ngIf='new_password.errors.required'>
          <p class='mb-0'>Password is required.</p>
        </div>
        <div *ngIf='new_password.errors.minlength'>
          <p class='mb-0'>Password must be at least 8 characters long.</p>
        </div>
        <div *ngIf='new_password.errors.pattern'>
          <ul>
            <li>Numbers: 0 to 9</li>
            <li>Uppercase Letters: ABC</li>
            <li>Lowercase Letters: abc</li>
            <li>Special Characters: ! @ # $ % & * ( ) _ + - = &#123;} [ ] ; : ' " < > , . ? /</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12 d-flex flex-column'>
      <mat-label>Confirm new password</mat-label>
      <app-text-field formControlName='confirm_password' placeholder='Confirm your new password'
                      type='password'></app-text-field>
      <div
        *ngIf='hasControlErrors(confirm_password)'
        class='alert alert-danger'>
        <div *ngIf='confirm_password.errors.required'>
          <p class='mb-0'>Please, repeat your password</p>
        </div>
        <div *ngIf='confirm_password.errors.minlength'>
          <p class='mb-0'>Password must be at least 8 characters long.</p>
        </div>
        <div *ngIf='confirm_password.errors.not_same_as'>
          <p class='mb-0'>Password didn't match as above</p>
        </div>
      </div>
    </div>
  </div>
  <div class='row mt-3'>
    <div class='col col-12'>
      <app-button
        [Click]='submitButtonProperties.onClick'
        [color]='submitButtonProperties.color'
        [size]='submitButtonProperties.size'
        [text]='submitButtonProperties.text'></app-button>
    </div>
  </div>
  <br />
  <div class='row'>
    <div class='col col-4'>
      <a class='ForgotPassword__link' routerLink='/login'>Login</a>
    </div>
    <div class='col col-4 text-center'>
      <a class='ForgotPassword__link' routerLink='/register'>Register</a>
    </div>
    <div class='col col-4 text-right'>
      <a class='ForgotPassword__link' routerLink='/forgot_password'
      >Didn't receive confirmation instructions?</a
      >
    </div>
  </div>
</div>
